export default {
  SET_SECOND_MENU (state, data) {
    state.secondMenu = data
  },

  SET_THIRD_MENU (state, data) {
    state.thirdMenu = data
  },

  SET_EVENTDATA: (state, data) => {
    state.eventData = data
  }
}
